import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  content: React.ReactNode;
}

export function TooltipIcon({ content }: Props) {
  const ref = useRef<HTMLElement>(null);
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

  return (
    <sup
      ref={ref as React.RefObject<HTMLElement>}
      onMouseEnter={() => {
        const r = ref.current?.getBoundingClientRect();
        if (r) setPos({ top: r.top, left: r.left + r.width / 2 });
      }}
      onMouseLeave={() => setPos(null)}
      style={{ cursor: 'help' }}
    >
      <i className="fas fa-question-circle text-primary" style={{ fontSize: 12 }} />
      {pos && createPortal(
        <div className="iio-tooltip-bubble" style={{ top: pos.top, left: pos.left }}>
          {content}
        </div>,
        document.body
      )}
    </sup>
  );
}
